let pianoChords = JSON.parse(`{
  "pianoChords": [
    {
      "type" : "C",
      "chords": [
        {
          "name": "C",
          "keys": [
            {"name": "C"},
            {"name": "E"},
            {"name": "G"}
          ]
        },
        {
          "name": "Cm",
          "keys": [
            {"name": "C"},
            {"name": "E♭"},
            {"name": "G"}
          ]
        },
        {
          "name": "C 7",
          "keys": [
            {"name": "C"},
            {"name": "E"},
            {"name": "G"},
            {"name": "B♭"}
          ]
        },
        {
          "name": "Cm 7",
          "keys": [
            {"name": "C"},
            {"name": "E♭"},
            {"name": "G"},
            {"name": "B♭"}
          ]
        },

        {
          "name": "C#",
          "keys": [
            {"name": "C#"},
            {"name": "F"},
            {"name": "G#"}
          ]
        },
        {
          "name": "C#m",
          "keys": [
            {"name": "C#"},
            {"name": "E"},
            {"name": "G#"}
          ]
        },
        {
          "name": "C# 7",
          "keys": [
            {"name": "C#"},
            {"name": "F"},
            {"name": "G#"},
            {"name": "B"}
          ]
        },
        {
          "name": "C# 7m",
          "keys": [
            {"name": "C#"},
            {"name": "E"},
            {"name": "G#"},
            {"name": "B"}
          ]
        }
      ]
    },
    {
      "type": "D",
      "chords": [
        {
          "name": "D♭",
          "keys": [
            {"name": "D♭"},
            {"name": "B"},
            {"name": "A♭"}
          ]
        },
        {
          "name": "D♭m",
          "keys": [
            {"name": "D♭"},
            {"name": "E"},
            {"name": "A♭"}
          ]
        },
        {
          "name": "D♭ 7",
          "keys": [
            {"name": "D♭"},
            {"name": "B"},
            {"name": "A♭"},
            {"name": "B"}
          ]
        },
        {
          "name": "D♭ 7m",
          "keys": [
            {"name": "D♭"},
            {"name": "E"},
            {"name": "A♭"},
            {"name": "B"}
          ]
        },
    
        {
          "name": "D",
          "keys": [
            {"name": "D"},
            {"name": "F#"},
            {"name": "A"}
          ]
        },
        {
          "name": "Dm",
          "keys": [
            {"name": "D"},
            {"name": "F"},
            {"name": "A"}
          ]
        },
        {
          "name": "D 7",
          "keys": [
            {"name": "D"},
            {"name": "F#"},
            {"name": "A"},
            {"name": "C"}
          ]
        },
        {
          "name": "Dm 7",
          "keys": [
            {"name": "D"},
            {"name": "F"},
            {"name": "A"},
            {"name": "C"}
          ]
        },
        
        {
          "name": "D#",
          "keys": [
            {"name": "D#"},
            {"name": "G"},
            {"name": "A#"}
          ]
        },
        {
          "name": "D#m",
          "keys": [
            {"name": "D#"},
            {"name": "F#"},
            {"name": "A#"}
          ]
        },
        {
          "name": "D# 7",
          "keys": [
            {"name": "D#"},
            {"name": "G"},
            {"name": "A#"},
            {"name": "C#"}
          ]
        },
        {
          "name": "D#m 7",
          "keys": [
            {"name": "D#"},
            {"name": "F#"},
            {"name": "A#"},
            {"name": "C#"}
          ]
        }
      ]
    },
    {
      "type": "E",
      "chords": [
        {
          "name": "E♭",
          "keys": [
            {"name": "E♭"},
            {"name": "G"},
            {"name": "B♭"}
          ]
        },
        {
          "name": "E♭m",
          "keys": [
            {"name": "E♭"},
            {"name": "G♭"},
            {"name": "B♭"}
          ]
        },
        {
          "name": "E♭ 7",
          "keys": [
            {"name": "E♭"},
            {"name": "G"},
            {"name": "B♭"},
            {"name": "D♭"}
          ]
        },
        {
          "name": "E♭m 7",
          "keys": [
            {"name": "E♭"},
            {"name": "G♭"},
            {"name": "B♭"},
            {"name": "D♭"}
          ]
        },
    
        {
          "name": "E",
          "keys": [
            {"name": "E"},
            {"name": "G#"},
            {"name": "B"}
          ]
        },
        {
          "name": "Em",
          "keys": [
            {"name": "E"},
            {"name": "G"},
            {"name": "B"}
          ]
        },
        {
          "name": "E 7",
          "keys": [
            {"name": "E"},
            {"name": "G#"},
            {"name": "B"},
            {"name": "D"}
          ]
        },
        {
          "name": "Em 7",
          "keys": [
            {"name": "E"},
            {"name": "G"},
            {"name": "B"},
            {"name": "D"}
          ]
        }
      ]
    },
    {
      "type": "F",
      "chords": [
        {
          "name": "F",
          "keys": [
            {"name": "F"},
            {"name": "A"},
            {"name": "C"}
          ]
        },
        {
          "name": "Fm",
          "keys": [
            {"name": "F"},
            {"name": "A♭"},
            {"name": "C"}
          ]
        },
        {
          "name": "F 7",
          "keys": [
            {"name": "F"},
            {"name": "A"},
            {"name": "C"},
            {"name": "E♭"}
          ]
        },
        {
          "name": "Fm 7",
          "keys": [
            {"name": "F"},
            {"name": "A♭"},
            {"name": "C"},
            {"name": "E♭"}
          ]
        },
    
        {
          "name": "F#",
          "keys": [
            {"name": "F#"},
            {"name": "A#"},
            {"name": "C#"}
          ]
        },
        {
          "name": "F#m",
          "keys": [
            {"name": "F#"},
            {"name": "A"},
            {"name": "C#"}
          ]
        },
        {
          "name": "F# 7",
          "keys": [
            {"name": "F#"},
            {"name": "A#"},
            {"name": "C#"},
            {"name": "E"}
          ]
        },
        {
          "name": "F#m 7",
          "keys": [
            {"name": "F#"},
            {"name": "A"},
            {"name": "C#"},
            {"name": "E"}
          ]
        }
      ]
    },
    {
      "type": "G",
      "chords": [
        {
          "name": "G♭",
          "keys": [
            {"name": "G♭"},
            {"name": "B♭"},
            {"name": "D♭"}
          ]
        },
        {
          "name": "G♭m",
          "keys": [
            {"name": "G♭"},
            {"name": "A"},
            {"name": "D♭"}
          ]
        },
        {
          "name": "G♭ 7",
          "keys": [
            {"name": "G♭"},
            {"name": "B♭"},
            {"name": "D♭"},
            {"name": "E"}
          ]
        },
        {
          "name": "G♭m 7",
          "keys": [
            {"name": "G♭"},
            {"name": "A"},
            {"name": "D♭"},
            {"name": "E"}
          ]
        },
    
        
        {
          "name": "G",
          "keys": [
            {"name": "G"},
            {"name": "B"},
            {"name": "D"}
          ]
        },
        {
          "name": "Gm",
          "keys": [
            {"name": "G"},
            {"name": "B♭"},
            {"name": "D"}
          ]
        },
        {
          "name": "G 7",
          "keys": [
            {"name": "G"},
            {"name": "B"},
            {"name": "D"},
            {"name": "F"}
          ]
        },
        {
          "name": "Gm 7",
          "keys": [
            {"name": "G"},
            {"name": "B♭"},
            {"name": "D"},
            {"name": "F"}
          ]
        },
    
    
        {
          "name": "G#",
          "keys": [
            {"name": "G#"},
            {"name": "C"},
            {"name": "D#"}
          ]
        },
        {
          "name": "G#m",
          "keys": [
            {"name": "G#"},
            {"name": "B"},
            {"name": "D#"}
          ]
        },
        {
          "name": "G# 7",
          "keys": [
            {"name": "G#"},
            {"name": "C"},
            {"name": "D#"},
            {"name": "F#"}
          ]
        },
        {
          "name": "G#m 7",
          "keys": [
            {"name": "G#"},
            {"name": "B"},
            {"name": "D#"},
            {"name": "F#"}
          ]
        }
      ]
    },
    {
      "type": "A",
      "chords": [
        {
          "name": "A♭",
          "keys": [
            {"name": "A♭"},
            {"name": "C"},
            {"name": "E♭"}
          ]
        },
        {
          "name": "A♭m",
          "keys": [
            {"name": "A♭"},
            {"name": "B"},
            {"name": "E♭"}
          ]
        },
        {
          "name": "A♭ 7",
          "keys": [
            {"name": "A♭"},
            {"name": "C"},
            {"name": "E♭"},
            {"name": "G♭"}
          ]
        },
        {
          "name": "A♭m 7",
          "keys": [
            {"name": "A♭"},
            {"name": "B"},
            {"name": "E♭"},
            {"name": "G♭"}
          ]
        },
    
        {
          "name": "A",
          "keys": [
            {"name": "A"},
            {"name": "C#"},
            {"name": "E"}
          ]
        },
        {
          "name": "Am",
          "keys": [
            {"name": "A"},
            {"name": "C"},
            {"name": "E"}
          ]
        },
        {
          "name": "A 7",
          "keys": [
            {"name": "A"},
            {"name": "C#"},
            {"name": "E"},
            {"name": "G"}
          ]
        },
        {
          "name": "Am 7",
          "keys": [
            {"name": "A"},
            {"name": "C"},
            {"name": "E"},
            {"name": "G"}
          ]
        },
    
    
        {
          "name": "A#",
          "keys": [
            {"name": "A#"},
            {"name": "D"},
            {"name": "F"}
          ]
        },
        {
          "name": "A#m",
          "keys": [
            {"name": "A#"},
            {"name": "C#"},
            {"name": "F"}
          ]
        },
        {
          "name": "A# 7",
          "keys": [
            {"name": "A#"},
            {"name": "D"},
            {"name": "F"},
            {"name": "G#"}
          ]
        },
        {
          "name": "A#m 7",
          "keys": [
            {"name": "A#"},
            {"name": "C#"},
            {"name": "F"},
            {"name": "G#"}
          ]
        }
      ]
    },
    {
      "type": "B",
      "chords": [
        {
          "name": "B♭",
          "keys": [
            {"name": "B♭"},
            {"name": "D"},
            {"name": "F"}
          ]
        },
        {
          "name": "B♭m",
          "keys": [
            {"name": "B♭"},
            {"name": "D♭"},
            {"name": "F"}
          ]
        },
        {
          "name": "B♭ 7",
          "keys": [
            {"name": "B♭"},
            {"name": "D"},
            {"name": "F"},
            {"name": "A♭"}
          ]
        },
        {
          "name": "B♭m 7",
          "keys": [
            {"name": "B♭"},
            {"name": "D♭"},
            {"name": "F"},
            {"name": "A♭"}
          ]
        },
    
        {
          "name": "B",
          "keys": [
            {"name": "B"},
            {"name": "D#"},
            {"name": "F#"}
          ]
        },
        {
          "name": "Bm",
          "keys": [
            {"name": "B"},
            {"name": "D"},
            {"name": "F#"}
          ]
        },
        {
          "name": "B 7",
          "keys": [
            {"name": "B"},
            {"name": "D#"},
            {"name": "F#"},
            {"name": "A"}
          ]
        },
        {
          "name": "Bm 7",
          "keys": [
            {"name": "B"},
            {"name": "D"},
            {"name": "F#"},
            {"name": "A"}
          ]
        }
      ]
    }
  ]
}`);

export {pianoChords}